/**
 * Saves a blob as a file through a temporary `<a download>`. The object URL is revoked right after the click: the
 * browser has already taken the blob by then, and a live URL would keep it in the tab's memory.
 */
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  try {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
  } finally {
    URL.revokeObjectURL(url);
  }
}
